export default __webpack_public_path__ + "static/media/Activeemoji_events.3c9cb408.svg";